import { Advt } from './Advt/Advt';
import styles from './Quiz.module.css';
import { CarouselAvatars } from './CarouselAvatars/CarouselAvatars';
import { Question } from './Question/Question';
import { AnimatePresence, motion } from 'motion/react';
import { useGetParams } from 'hooks/useGetParams';

export const Quiz = ({
  isFirstState,
  showedMessagesF2,
  voteState,
  currentState,
  QUIZ_ADVT,
  QUIZ_AVATARS,
  CORRECT_VAR,
}) => {
  const { title } = useGetParams();

  if (!voteState) return null;

  const { title: question, vars } = voteState;

  const initDelay = 1;
  const varDelay = 0.4;

  const isCorrectVarState = currentState === CORRECT_VAR;

  return (
    <motion.div
      className={styles.quizWrapper}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <div className={styles.quizContent}>
        <Question question={question} />
        <motion.div
          className={styles.advtTitle}
          initial={{ scale: 0, originX: '0%', originY: 'center' }}
          animate={{ scale: 1 }}
          transition={{ duration: 1 }}
        >
          {title}
        </motion.div>
        <div className={styles.varsBlock}>
          {vars.map((v, idx) => {
            const isCorrect = v.correct && isCorrectVarState;

            return (
              <motion.div
                initial={{
                  scale: 1,
                  backgroundImage:
                    'linear-gradient(0deg, rgb(0, 0, 0, 0),  rgb(0, 0, 0, 0))',
                  opacity: 1,
                }}
                animate={{
                  scale: isCorrect ? 1.2 : 1,
                  backgroundImage: isCorrect
                    ? 'linear-gradient(0deg, rgb(12, 183, 196, 1),  rgb(199, 0, 58, 1))'
                    : 'linear-gradient(0deg, rgb(0, 0, 0, 0),  rgb(0, 0, 0, 0))',
                  opacity: isCorrect ? [1, 0, 1, 0, 1] : 1,
                }}
                transition={{
                  scale: {
                    duration: 1,
                    delay: !isFirstState ? 0 : varDelay * idx + initDelay,
                  },
                  backgroundImage: {
                    duration: 0.5,
                    delay: !isFirstState ? 0 : varDelay * idx + initDelay,
                  },
                  opacity: {
                    duration: 2,
                    delay:
                      0.5 + (!isFirstState ? 0 : varDelay * idx + initDelay),
                  },
                }}
                key={v.varnum}
                className={styles.varItemBlock}
              >
                <div className={styles.varItem}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{
                      duration: 0.24,
                      delay: varDelay * idx + initDelay,
                    }}
                    className={styles.varNum}
                  >
                    {v.varnum}
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.88,
                      delay: varDelay * idx + initDelay,
                    }}
                    className={styles.varComment}
                  >
                    {v.comment}
                  </motion.div>

                  <motion.div
                    initial={{ maskPosition: '0% 100%, 100% 0%' }}
                    animate={{ maskPosition: '100% 100%, 0% 0%' }}
                    transition={{
                      duration: 0.4,
                      delay: varDelay * idx + initDelay,
                    }}
                    className={styles.varBorder1}
                  />
                  <motion.div
                    initial={{ maskPosition: '100% 0%' }}
                    animate={{ maskPosition: '0% 0%' }}
                    transition={{
                      duration: 0.4,
                      delay: varDelay * idx + 0.4 + initDelay,
                    }}
                    className={styles.varBorder2}
                  />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      <div className={styles.quizBottom}>
        <AnimatePresence mode="wait">
          {currentState === QUIZ_ADVT && (
            <Advt key="advt" initDelay={initDelay} />
          )}
          {currentState === QUIZ_AVATARS && (
            <CarouselAvatars key="carousel" messages={showedMessagesF2} />
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};
